var map = {
	"./2003_cloud_cover.zip": 779,
	"./2004_cloud_cover.zip": 9724,
	"./2005_cloud_cover.zip": 5445,
	"./2006_cloud_cover.zip": 926,
	"./2007_cloud_cover.zip": 5887,
	"./2008_cloud_cover.zip": 4272,
	"./2009_cloud_cover.zip": 601,
	"./2010_cloud_cover.zip": 8999,
	"./2011_cloud_cover.zip": 5126,
	"./2012_cloud_cover.zip": 5805,
	"./2013_cloud_cover.zip": 4516,
	"./2014_cloud_cover.zip": 7299,
	"./2015_cloud_cover.zip": 7154,
	"./2016_cloud_cover.zip": 6921,
	"./2017_cloud_cover.zip": 2256,
	"./2018_cloud_cover.zip": 2479,
	"./2019_cloud_cover.zip": 3822,
	"./2020_cloud_cover.zip": 9090,
	"./2021_cloud_cover.zip": 3731,
	"./2023_cloud_cover.zip": 2169
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6084;
module.exports = webpackAsyncContext;